import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { useCheckPermissions } from '@user/store/authorization/permissions'

export function useCwqClosedLostEnabled(
  soldServiceStatus: SOLD_SERVICE_STATUS,
): boolean {
  const [canUpdateOpportunity] = useCheckPermissions('opportunities_update')

  return (
    canUpdateOpportunity && soldServiceStatus === SOLD_SERVICE_STATUS.Completed
  )
}
